import { connect } from 'react-redux'
import { isOffline } from 'redux-offline-status'

import ErrorBoundary from './ErrorBoundary'

const mapStateToProps = (state) => {
  return {
    isOffline: isOffline(state)
  }
}

export default connect(mapStateToProps)(ErrorBoundary)
